import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Label,
} from "recharts";
import "../TotalReportAnalysis/TotalReportAnalysis.css";

// Sample data
const data = [
  { date: "Daily", reports: 7000 },
  { date: "Weekly", reports: 5000 },
  { date: "Monthly", reports: 3000 },
];

const colors = ["#a5bcfc", "#c7d7fe", "#dcdcdc"];

const CustomBar = (props) => {
  const { fill, x, y, width, height, index } = props;
  const radius = 10; // Rounded corner radius

  return (
    <path
      d={`M${x},${y + radius} 
         a${radius},${radius} 0 0,1 ${radius},-${radius} 
         h${width - radius * 2} 
         a${radius},${radius} 0 0,1 ${radius},${radius} 
         v${height - radius} 
         h-${width} 
         Z`}
      fill={fill} // Use the solid color passed via props
    />
  );
};

const TotalReportAnalysis = () => {
  return (
    <section className="section">
      <div className="full-report-container">
        <div className="full-report-header">
          <h1>Total Reports Published and Their Status Analysis</h1>
        </div>

        <div className="full-report-parent">
          <div className="full-report-chart-container">
            <ResponsiveContainer width="100%" height={420}>
              <BarChart
                data={data}
                margin={{ top: 40, right: 30, left: 40, bottom: 40 }}
              >
                {/* Chart Title */}
                <CartesianGrid
                  stroke="#d6d6d6"
                  strokeDasharray="0 0"
                  horizontal={true}
                  vertical={false}
                />

                {/* X-Axis with Title */}
                <XAxis
                  dataKey="date"
                  tick={{ fontSize: "16px", fill: "#999" }} // Updated tick font size and color
                >
                  <Label
                    value="Time Period"
                    position="insideLeft"
                    offset={0}
                    style={{ fontSize: "16px", fill: "#999" }} // Updated label font size and color
                    dy={25}
                  />
                </XAxis>

                {/* Y-Axis with Title */}
                <YAxis
                  tick={{ fontSize: "16px", fill: "#999" }} // Updated tick font size and color
                >
                  <Label
                    value="Number of Reports"
                    angle={-90}
                    position="insideBottom"
                    style={{ fontSize: "16px", fill: "#999" }} // Updated label font size and color
                    dy={-55}
                    dx={-35}
                  />
                </YAxis>

                <Tooltip
                  cursor={{ fill: "transparent" }}
                  labelStyle={{
                    fontSize: "16px", // Updated tooltip label font size
                    color: "#000", // Updated tooltip label color
                  }}
                  itemStyle={{
                    fontSize: "16px", // Updated tooltip item font size
                    color: "#999", // Updated tooltip item color
                  }}
                  formatter={(value) => [`${value}k`, "Reports (Count)"]}
                />

                <Bar
                  dataKey="reports"
                  shape={(props) => {
                    const color = colors[props.index % colors.length];
                    return <CustomBar {...props} fill={color} />;
                  }}
                  barSize={window.innerWidth < 1400 ? 50 : 50} // Dynamic bar size for smaller screens
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div className="full-report-legend-table">
            <table>
              <thead>
                <tr className="full-thead">
                  <td>Legend</td>
                  <td>Name</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <i
                      className="fa-solid fa-circle"
                      style={{ color: "#a5bcfc" }}
                    ></i>
                  </td>
                  <td>Daily</td>
                </tr>
                <tr>
                  <td>
                    <i
                      className="fa-solid fa-circle"
                      style={{ color: "#c7d7fe" }}
                    ></i>
                  </td>
                  <td>Weekly</td>
                </tr>
                <tr>
                  <td>
                    <i
                      className="fa-solid fa-circle"
                      style={{ color: "#dcdcdc" }}
                    ></i>
                  </td>
                  <td>Monthly</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TotalReportAnalysis;
